module.exports = __webpack_public_path__ + "img/provider2.1bd8229d.png";